var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modal2
        ? _c(
            "el-dialog",
            {
              attrs: { title: "物流轨迹", visible: _vm.modal2, width: "600px" },
              on: {
                "update:visible": function ($event) {
                  _vm.modal2 = $event
                },
              },
            },
            [
              [
                _vm.result && _vm.result.length
                  ? _c(
                      "el-tabs",
                      { attrs: { type: "border-card" } },
                      _vm._l(_vm.result, function (transportItem, i) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: i,
                            attrs: {
                              label:
                                (transportItem.deliveryName || "") +
                                "  " +
                                transportItem.nu,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "logistics acea-row row-top" },
                              [
                                _c("div", { staticClass: "logistics_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/imgs/expressi.jpg"),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "logistics_cent" }, [
                                  _c("span", { staticClass: "mb10" }, [
                                    _vm._v(
                                      "物流公司：" +
                                        _vm._s(
                                          transportItem.deliveryName || "--"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "物流单号：" +
                                        _vm._s(transportItem.nu || "--")
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "物流状态：" +
                                        _vm._s(transportItem.stateMsg || "--")
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "acea-row row-column-around trees-coadd",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "scollhide" },
                                  [
                                    _c(
                                      "el-timeline",
                                      { attrs: { reverse: _vm.reverse } },
                                      _vm._l(
                                        transportItem.data,
                                        function (item, i) {
                                          return _c(
                                            "el-timeline-item",
                                            { key: i },
                                            [
                                              _c("p", {
                                                staticClass: "time",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.time
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass: "content",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.context
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _c("div", [_vm._v("暂无物流轨迹")]),
              ],
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }